

export function isObject(value) {
  return value && typeof value === 'object' && value.constructor === Object;
}

export function isArray(value) {
  return value && typeof value === 'object' && value.constructor === Array;
}

let inThrottle = false;
export const throttle = (cb: Function, interval?: number) => {
  if (!inThrottle) {
    cb.apply(this);
    inThrottle = true;
    setTimeout(() => { inThrottle = false; }, interval || 3000);
  }
};

export function removeEmptyObjects(arr: Array<any>) {
  const newArray = [];
  arr.forEach(obj => {
    for (const key in obj) {
      if (obj[key]) {
        newArray.push(obj);
        return;
      }
    }
  });
  return newArray;
}